import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify' // Asegúrate de que esta ruta sea correcta
import i18n from './i18n'
const pinia = createPinia()
const app = createApp(App)
app.use(pinia)

app.use(i18n)

app.use(router)
app.use(vuetify)
// Si necesitas usar una store fuera de un componente, hazlo después de montar la aplicación
// import { useAuthStore } from '@/stores/authStore'
// const authStore = useAuthStore()
// if (authStore.isAuthenticated) {
//   // authStore.fetchUser()
// }

app.mount('#app')
